/**
 * @ngdoc service
 * @name checkins.factory:showPicklistContact
 *
 * @description
 *
 */
angular
    .module('festzelt-os.picklists')
    .factory('showPicklistContact', [
        '$state',
        showPicklistContact
    ]);

function showPicklistContact($state) {
    return {
        key: 'show-picklist-contact',
        title: 'Contacts',
        level: 'row',
        class: 'btn btn-default btn-sm',
        action: function ({row}, store) {
            $state.go('app.picklists.contacts.details', {
                pid: store.state.vm.picklist.id,
                picklist: store.state.vm.picklist,
                cid: row.id,
                contact: row,
                store: store
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/picklists/workflows/general/show-picklist-contact.js